import { render } from "./CredibilityBlock.vue?vue&type=template&id=77d33e12&scoped=true"
import script from "./CredibilityBlock.vue?vue&type=script&lang=js"
export * from "./CredibilityBlock.vue?vue&type=script&lang=js"

import "./CredibilityBlock.vue?vue&type=style&index=0&id=77d33e12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d33e12"]])

export default __exports__